import { CircularProgress } from '@mui/material';
import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { getAuthToken } from '../../../utils/token';

const ExtensionLogin = () => {
  const [params] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (getAuthToken()) {
      if (params.get('app') == 'extension' && params.get('extensionId')) {
      /* eslint-disable */
    chrome.runtime.sendMessage(params.get("extensionId")?.toString(), {
      type: 'authtoken',
      token:getAuthToken(),
    });    
    window.close();

   }else if(params.get('app') == "ignite"){
     window.open(`ignite://action=login&token=${getAuthToken()}`);
     window.close();
}}else{
      navigate(`/?appType=${params.get('appType')}&app=${params.get("app")}&extensionId=${params.get('extensionId')}`);
   }
  }, []);
  return <CircularProgress />;
};
export default ExtensionLogin;
